import { render, staticRenderFns } from "./Reuniones.vue?vue&type=template&id=476c7482&"
import script from "./Reuniones.vue?vue&type=script&lang=js&"
export * from "./Reuniones.vue?vue&type=script&lang=js&"
import style0 from "./Reuniones.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports